import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
} // In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.


var isLocalhost = Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
/**
 * Callback fired when there is a new app (service worker) version waiting to
 * activate. It is called with a single argument: a callback function that
 * expects a boolean to be returned indicating if the new service worker should
 * be activated or not. This callback should be used by the `ActivationCallback`
 * function to prompt the user to either activate the new version or ignore it,
 * falling back to the default behavior of the service worker spec (which is to
 * activate the service worker once the current one becomes inactive).
 * @typedef {Function} ActivationCallback
 * @param {Function} callback - function expected to return a boolean value
 * indicating if the new service worker should be activated or not
 */

/**
 * To improve the new app version installation experience, we must listen for a
 * `.waiting` ServiceWorker, which requires some additional boilerplate code.
 * The registration fires an `updatefound` event when there’s a new `.installing`
 * ServiceWorker; the `.installing` ServiceWorker fires a `statechange` event
 * once it's in the "installed" waiting state.
 * @param {Object} registration - a service worker registration
 * @param {ActivationCallback} onAwaitingActivation - callback fired when a new
 * service worker is waiting to activate
 */

export var handleRegistrationSuccess = function handleRegistrationSuccess(registration, onAwaitingActivation) {
  if (!registration) return;
  /**
   * Callback that allows `handleRegistrationSuccess` to defer responsibility
   * of deciding if/when to activate a service worker awaiting activation to
   * the `onAwaitingActivation` function.
   * @param {boolean} shouldActivate - whether or not a service worker that is
   * awaiting activation should be activated
   */

  var handleShouldActivate = function handleShouldActivate(shouldActivate) {
    if (shouldActivate) sendCommand('skipWaiting', registration.waiting);
  }; // fire `onAwaitingActivation` if new service worker is awaiting activation


  if (registration.waiting) return onAwaitingActivation(handleShouldActivate);

  var handleServiceWorkerUpdate = function handleServiceWorkerUpdate() {
    registration.installing.addEventListener('statechange', function () {
      if (this.state === 'installed') {
        if (navigator.serviceWorker.controller) {
          // At this point, the old content will have been purged and
          // the fresh content will have been added to the cache.
          // It's the perfect time to display a "New content is
          // available; please refresh." message in your web app.
          console.log('New content is available; please refresh the page.'); // Freshly installed service worker should be awaiting activation

          onAwaitingActivation(handleShouldActivate);
        } else {
          // At this point, everything has been precached.
          // It's the perfect time to display a
          // "Content is cached for offline use." message.
          console.log('Content is cached for offline use.');
        }
      }
    });
  }; // if service worker is already installing, call `handleServiceWorkerUpdate`
  // to ensure it's `statechange` events are captured and handled appropriately


  if (registration.installing) handleServiceWorkerUpdate(); // call `handleServiceWorkerUpdate` when an updated service worker is found

  registration.addEventListener('updatefound', handleServiceWorkerUpdate);
};
/**
 * Attempts to register the service worker at `${PUBLIC_URL}/service-worker.js`.
 * A callback function can be provided that will be fired when an updated
 * service worker is awaiting activation.
 * @param {ActivationCallback} onAwaitingActivation callback fired when an
 * updated service worker is awaiting activation
 */

export function register(onAwaitingActivation) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // the URL constructor is available in all browsers that support SW
    var publicUrl = new URL(process.env.PUBLIC_URL, window.location);
    /**
     * Our service worker won't work if PUBLIC_URL is on a different origin
     * from what our page is served on. This might happen if a CDN is used to
     * serve assets.
     * @see {@link https://github.com/facebookincubator/create-react-app/issues/2374}
     */

    if (publicUrl.origin !== window.location.origin) return;
    window.addEventListener('load', function () {
      var swUrl = "".concat(process.env.PUBLIC_URL, "/service-worker.js"); // if running on localhost, we must check if a service worker still exists
      // or not before registering

      var registerServiceWorker = isLocalhost ? validateAndRegisterServiceWorker : registerValidServiceWorker; // use appropriate registration function to register service worker

      registerServiceWorker(swUrl, onAwaitingActivation);
    });
  }
}
/**
 * Provided a valid sw URL, registers the service worker located at said URL.
 * @param {string} swUrl - URL of service worker to register
 * @param {ActivationCallback} onAwaitingActivation - callback fired when an
 * updated service worker is awaiting activation
 */

function registerValidServiceWorker(_x, _x2) {
  return _registerValidServiceWorker.apply(this, arguments);
}
/**
 * Validate that a service worker exists at the provided URL before attempting
 * to register it.
 * @param {string} swUrl - URL of service worker to register
 * @param {ActivationCallback} onAwaitingActivation - callback fired when an
 * updated service worker is awaiting activation
 */


function _registerValidServiceWorker() {
  _registerValidServiceWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(swUrl, onAwaitingActivation) {
    var refreshing, registration;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // reloads all tabs any time a new Service Worker takes over
            navigator.serviceWorker.addEventListener('controllerchange', function () {
              if (refreshing) return;
              refreshing = true;
              window.location.reload();
            });
            _context.prev = 1;

            if (!window.Cypress) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return unregister();

          case 5:
            _context.next = 11;
            break;

          case 7:
            _context.next = 9;
            return navigator.serviceWorker.register(swUrl);

          case 9:
            registration = _context.sent;
            handleRegistrationSuccess(registration, onAwaitingActivation);

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.error('Error during service worker registration:', _context.t0);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return _registerValidServiceWorker.apply(this, arguments);
}

function validateAndRegisterServiceWorker(_x3, _x4) {
  return _validateAndRegisterServiceWorker.apply(this, arguments);
}

function _validateAndRegisterServiceWorker() {
  _validateAndRegisterServiceWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(swUrl, onAwaitingActivation) {
    var response, is404, isJavascriptFile, registration;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(swUrl);

          case 3:
            response = _context2.sent;
            _context2.next = 9;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0); // fetch failed, so we assume user is offline

            console.log('No internet connection found. App is running in offline mode.');

          case 9:
            is404 = response.status === 404;
            isJavascriptFile = response.headers.get('content-type').includes('javascript'); // ensure service worker exists and that we really are getting a JS file

            if (!(is404 || !isJavascriptFile)) {
              _context2.next = 19;
              break;
            }

            _context2.next = 14;
            return navigator.serviceWorker.ready;

          case 14:
            registration = _context2.sent;
            _context2.next = 17;
            return registration.unregister();

          case 17:
            window.location.reload();
            return _context2.abrupt("return");

          case 19:
            // service worker found at URL, attempt to register it
            registerValidServiceWorker(swUrl, onAwaitingActivation);

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _validateAndRegisterServiceWorker.apply(this, arguments);
}

export function unregister() {
  return _unregister.apply(this, arguments);
}
/**
 * @typedef {Object} ServiceWorkerMessage
 * @property {String} command - command to execute in the service worker
 * @property {Array<*>} [args] - list of arguments for the command
 * @global
 */

/**
 * Sends a command to a service worker.
 * @param {string} command - service worker command
 * @param {Object} [registration=navigator.serviceWorker.controller] - a service
 * worker registration (defaults to the active registration)
 * @param {...*} [args] - arguments to pass through to the command
 * @return {Promise} - promise that resolves once message has been sent
 */

function _unregister() {
  _unregister = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var registration;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!('serviceWorker' in navigator)) {
              _context3.next = 5;
              break;
            }

            _context3.next = 3;
            return navigator.serviceWorker.ready;

          case 3:
            registration = _context3.sent;
            registration.unregister();

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _unregister.apply(this, arguments);
}

export function sendCommand(_x5) {
  return _sendCommand.apply(this, arguments);
}

function _sendCommand() {
  _sendCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(command) {
    var _len,
        args,
        _key,
        swReadyTimeout,
        swReadyTimeoutDuration,
        rejectOnTimeout,
        swReadyPromise,
        _args4,
        _args5,
        registration,
        rest,
        _args6 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            for (_len = _args6.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = _args6[_key];
            }

            if (!(process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator)) {
              _context4.next = 19;
              break;
            }
            /**
             * There is an edge case where the `navigator.serviceWorker.ready` promise
             * never resolves, which would cause the promise returned from `sendMessage`
             * to hang indefinitely. To address this, we race the sw ready promise
             * against a timeout promise that resolves after some amount of time has
             * elapsed.
             */
            // NOTE: there is no rhyme or reason to why I chose 5 seconds as the
            // duration... it just seemed like a reasonable duration - Joel K


            swReadyTimeoutDuration = 5000; // promise that resolves after the timeout duration has elapsed (used to
            // race against `navigator.serviceWorker.ready`)

            rejectOnTimeout = new Promise(function (resolve, reject) {
              swReadyTimeout = setTimeout(function () {
                return reject('timeout');
              }, swReadyTimeoutDuration);
            }); // promise that clears the `swReadyTimeout` timeout after sw ready promise
            // resolves

            swReadyPromise = navigator.serviceWorker.ready.then(function () {
              return clearTimeout(swReadyTimeout);
            });
            _context4.prev = 5;
            _context4.next = 8;
            return Promise.race([swReadyPromise, rejectOnTimeout]);

          case 8:
            _context4.next = 13;
            break;

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](5);
            console.warn('Unable to send message; service worker registration timed out.');

          case 13:
            _args4 = args, _args5 = _toArray(_args4), registration = _args5[0], rest = _args5.slice(1); // if a service worker registration is provided as the second argument (it's
            // optional), `args` is re-assigned to the array of remaining arguments

            if (registration instanceof ServiceWorker) {
              args = rest;
            } else {
              // if a registration is not provided, default to the active one and leave
              // `args` as is
              registration = navigator.serviceWorker.controller;
            } // a service worker is considered to be a progressive enhancement; as such,
            // if there is no active service worker to message, it is considered a
            // warning and not an error


            if (registration) {
              _context4.next = 18;
              break;
            }

            console.warn('Unable to send message; service worker not active.');
            return _context4.abrupt("return");

          case 18:
            // finally send the message to the registered service worker
            registration.postMessage({
              command: command,
              args: args
            });

          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[5, 10]]);
  }));
  return _sendCommand.apply(this, arguments);
}

export default {
  register: register,
  unregister: unregister,
  sendCommand: sendCommand
};